export default "__VITE_ASSET__Bqhi0$R$__"